import FlightCreditDetails from "./FlightCreditDetails";

const FlightCreditDetailWrapper = () => {
  return <FlightCreditDetails />;
};
export default FlightCreditDetailWrapper;
